function LandingAd(){
    return(
        <>

            <div className="landing-ad">
                <div className="container">
                    <div className="landing-ad-content">
                        <h1 data-aos-delay="100" data-aos="fade-in">
                            "Documenting the moment" .. in sound and image.
                        </h1>

                        {/* <p>
                            WE ARE PROEFFECT  <br/>
                            Creative Production House <br/> 
                        </p> */}
                    </div>  
                </div>
            </div>
        
        </>
    )
}

export default LandingAd;